import { type EventName, type EventProperties, useTrackCallback } from '@/lib/analytics/events'
import { isAbsoluteUrl } from '@/lib/string/string-validators'

import { Link, type LinkProps } from './link'

export type HyperlinkProps = Omit<LinkProps, 'variant'> & {
  trackingEvent?: EventName
  extraTrackingProps?: EventProperties
}

export const Hyperlink = ({
  href,
  children,
  className,
  trackingEvent,
  extraTrackingProps,
  ...props
}: HyperlinkProps) => {
  const trackClick = useTrackCallback(trackingEvent || 'hyperlink_clicked')

  if (!href) {
    return <span>{children}</span>
  }

  const isAbsolute = isAbsoluteUrl(href)

  return (
    <Link
      variant='hyperlink'
      className={className}
      href={href}
      target={isAbsolute ? '_blank' : '_self'}
      rel={isAbsolute ? 'noopener noreferrer' : undefined}
      onClick={trackingEvent ? () => trackClick(extraTrackingProps) : undefined}
      {...props}
    >
      {children}
    </Link>
  )
}
